
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   MSKASSESSMENT_ACTION, 
   ALL_MSKASSESSMENT,
   CHECK_MSKASSESSMENT,
   CHECK_MSKASSESSMENT_DONE,
   ADD_MSKASSESSMENT,
   ADD_MSKASSESSMENT_SUCCESS,
   ADD_MSKASSESSMENT_FAILURE,
   FETCH_MSKASSESSMENT,
   EDIT_MSKASSESSMENT,
   EDIT_MSKASSESSMENT_SUCCESS,
   EDIT_MSKASSESSMENT_FAILURE,
   DELETE_MSKASSESSMENT_SUCCESS,
   DELETE_MSKASSESSMENT_FAILURE,
   ALL_POSTURE_HEAD,
   ALL_POSTURE_SHOULDERS,
   ALL_POSTURE_THORACIC,
   ALL_POSTURE_LUMBAR,
   ALL_POSTURE_PELVIS,
   ALL_POSTURE_KNEE,
   ALL_POSTURE_FEET,
   ALL_POSTURE_GLENOHUMERAL,
   ALL_POSTURE_ABBREIVATION,
   REPORT_MSKASSESSMENT,
   FETCH_MSKMEDICAL,
   REPORT_MSKDATES
} from 'Actions/types';

/**
 * Redux Action To Sigin User With Firebase
 */
export const allMskAssessment = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: MSKASSESSMENT_ACTION });
        axios.get(AppConfig.apiurl+'/api/getCreatedAssessment', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_MSKASSESSMENT, payload: allroles });
        });
    }    

}

export const checkMskAssessment = (studentid,date,quarter) => async (dispatch) => {
	
        var payload={
			"studentid":studentid,
			"adate":date,
			"quarter":quarter
		}
        
		  dispatch({ type: CHECK_MSKASSESSMENT});
	   	  return axios.post(AppConfig.apiurl+'/api/checkForAssessmentDate', payload, { headers: AuthHeader.header })
				.then( response => {   
					var resdata=response.data;				
					dispatch({ type: CHECK_MSKASSESSMENT_DONE}); 
					return Promise.resolve(resdata);
					
				})
				.catch( error => { 
					const errormsg=error.message
					NotificationManager.error(errormsg);
				});
	
		
}

export const addMskAssessment = (mskstate) => async (dispatch) => {
	       

			var payload={
				"userid":mskstate.target.student.value,
				"quarter":mskstate.target.quarter.value,
				"assdate":mskstate.target.seldate.value,

				"mskassessor":mskstate.target.mskassessor.value,
				"mskskill":mskstate.target.mskskill.value,
				"medicalhistory":mskstate.target.medicalhistory.value,
				"medicalrecord":mskstate.target.medicalrecord.value,
				"allergies":mskstate.target.allergies.value,
				"injuryhistory":mskstate.target.injuryhistory.value,
				"head":mskstate.target.head.value,
				"shoulders":mskstate.target.shoulders.value,
				"thoracic_spine":mskstate.target.thoracic_spine.value,
				"lumbar_spine":mskstate.target.lumbar_spine.value,
				"spine_pelvis":mskstate.target.spine_pelvis.value,
				"knee_posture":mskstate.target.knee_posture.value,
				"feet":mskstate.target.feet.value,
				"glenohumeral_rhythm":mskstate.target.glenohumeral_rhythm.value,
				"glenohumeral_rhythm": mskstate.target.glenohumeral_rhythm.value,
				"shoulders_internal_rota_n_rt": mskstate.target.shoulders_internal_rota_n_rt.value,
				"shoulders_internal_rota_n_lt": mskstate.target.shoulders_internal_rota_n_lt.value,
				"shoulders_external_rota_rt": mskstate.target.shoulders_external_rota_rt.value,
				"shoulders_external_rota_lt": mskstate.target.shoulders_external_rota_lt.value,
				"gird_erg_rt": mskstate.target.gird_erg_rt.value,
				"gird_erg_lt": mskstate.target.gird_erg_lt.value,
				"kibler_one_rt_one": mskstate.target.kibler_one_rt_one.value,
				"kibler_one_rt_two": mskstate.target.kibler_one_rt_two.value,
				"kibler_one_lt_one": mskstate.target.kibler_one_lt_one.value,
				"kibler_one_lt_two": mskstate.target.kibler_one_lt_two.value,

				"kibler_two_rt_one": mskstate.target.kibler_two_rt_one.value,
				"kibler_two_rt_two": mskstate.target.kibler_two_rt_two.value,
				"kibler_two_lt_one": mskstate.target.kibler_two_lt_one.value,
				"kibler_two_lt_two": mskstate.target.kibler_two_lt_two.value,

				"kibler_three_rt_one": mskstate.target.kibler_three_rt_one.value,
				"kibler_three_rt_two": mskstate.target.kibler_three_rt_two.value,
				"kibler_three_lt_one": mskstate.target.kibler_three_lt_one.value,
				"kibler_three_lt_two": mskstate.target.kibler_three_lt_two.value,

				"lat_muscle_length_rt": mskstate.target.lat_muscle_length_rt.value,
				"lat_muscle_length_lt": mskstate.target.lat_muscle_length_lt.value,
				"hk_impingement_test_rt": mskstate.target.hk_impingement_test_rt.value,
				"hk_impingement_test_lt": mskstate.target.hk_impingement_test_lt.value,
				"empty_can_test_rt": mskstate.target.empty_can_test_rt.value,
				"empty_can_test_lt": mskstate.target.empty_can_test_lt.value,
				"full_can_test_rt": mskstate.target.full_can_test_rt.value,
				"full_can_test_lt": mskstate.target.full_can_test_lt.value,
				"infraspinatus_strength_rt": mskstate.target.infraspinatus_strength_rt.value,
				"infraspinatus_strength_lt": mskstate.target.infraspinatus_strength_lt.value,
				"spine_quadrant_test_rt": mskstate.target.spine_quadrant_test_rt.value,
				"spine_quadrant_test_lt": mskstate.target.spine_quadrant_test_lt.value,
				"trendelenberg_sign_rt": mskstate.target.trendelenberg_sign_rt.value,
				"trendelenberg_sign_lt": mskstate.target.trendelenberg_sign_lt.value,
				"hip_quadrant_test_rt": mskstate.target.hip_quadrant_test_rt.value,
				"hip_quadrant_test_lt": mskstate.target.hip_quadrant_test_lt.value,
				"post_impingement_test_rt": mskstate.target.post_impingement_test_rt.value,
				"post_impingement_test_lt": mskstate.target.post_impingement_test_lt.value,
				"combined_elevation": mskstate.target.combined_elevation_test.value,
				"trunk_forward_flexion": mskstate.target.trunk_forward_flexion.value,
				"trunk_extension": mskstate.target.trunk_extension.value,
				"trunk_side_flexion_rt": mskstate.target.trunk_side_flexion_rt.value,
				"trunk_side_flexion_lt": mskstate.target.trunk_side_flexion_lt.value,
				"hamstring_length_rt": mskstate.target.hamstring_length_rt.value,
				"hamstring_length_lt": mskstate.target.hamstring_length_lt.value,
				"iliopsoas_muscle_length_rt": mskstate.target.iliopsoas_muscle_length_rt.value,
				"iliopsoas_muscle_length_lt": mskstate.target.iliopsoas_muscle_length_lt.value,
				"quad_muscle_rt": mskstate.target.quad_musclelength_rt.value,
				"quad_muscle_lt": mskstate.target.quad_musclelength_lt.value,
				"hip_internal_rotation_rt": mskstate.target.hip_internal_rotation_rt.value,
				"hip_internal_rotation_lt": mskstate.target.hip_internal_rotation_lt.value,
				"hip_external_rotation_rt": mskstate.target.hip_external_rotation_rt.value,
				"hip_external_rotation_lt": mskstate.target.hip_external_rotation_lt.value,
				"piriformis_ms_length_rt": mskstate.target.piriformis_ms_length_rt.value,
				"piriformis_ms_length_lt": mskstate.target.piriformis_ms_length_lt.value,
				"df_lunge_test_rt": mskstate.target.df_lunge_test_rt.value,
				"df_lunge_test_lt": mskstate.target.df_lunge_test_lt.value,
				"single_leg_eye_open_rt": mskstate.target.single_leg_eye_open_rt.value,
				"single_leg_eye_open_lt": mskstate.target.single_leg_eye_open_lt.value,
				"single_leg_eye_close_rt": mskstate.target.single_leg_eye_closed_rt.value,
				"single_leg_eye_close_lt": mskstate.target.single_leg_eye_closed_lt.value,				
				"leg_length_rt": mskstate.target.leg_length_rt.value,
				"leg_length_lt": mskstate.target.leg_length_lt.value,
				"glute_level_one_rt": mskstate.target.glute_level_one_rt.value,
				"glute_level_one_lt": mskstate.target.glute_level_one_lt.value,
				"glute_level_two_rt": mskstate.target.glute_level_two_rt.value,
				"glute_level_two_lt": mskstate.target.glute_level_two_lt.value,
				"glute_level_three_rt": mskstate.target.glute_level_three_rt.value,
				"glute_level_three_lt": mskstate.target.glute_level_three_lt.value,
				"glute_level_impression": mskstate.target.glute_level_impression.value,
				"tacontrol_level_one": mskstate.target.tacontrol_level_one.value,
				"tacontrol_level_two": mskstate.target.tacontrol_level_two.value,
				"tacontrol_level_three": mskstate.target.tacontrol_level_three.value,
				"tacontrol_level_four": mskstate.target.tacontrol_level_four.value, 
				"tacontrol_level_five": mskstate.target.tacontrol_level_five.value,
				
				"overall_impression_one": mskstate.target.overall_impression_one.value,
				"overall_impression_two": mskstate.target.overall_impression_two.value,
				"overall_impression_three": mskstate.target.overall_impression_three.value,
				"overall_impression_four": mskstate.target.overall_impression_four.value,
				"overall_impression_five": mskstate.target.overall_impression_five.value,
				"overall_impression_six": mskstate.target.overall_impression_six.value,
				"overall_impression_seven": mskstate.target.overall_impression_seven.value,
				"overall_impression_eight": mskstate.target.overall_impression_eight.value,

				"head_approach" : mskstate.target.head_approach.value, 
				"spine_approach" : mskstate.target.spine_approach.value,
				"knee_approach" : mskstate.target.knee_approach.value,
				"feet_approach" : mskstate.target.feet_approach.value,
				"glenohumeral_approach" : mskstate.target.glenohumeral_approach.value,
				"shoulders_internal_approach" : mskstate.target.shoulders_internal_approach.value,
				"gird_erg_approach" : mskstate.target.gird_erg_approach.value,
				"kibler_one_approach" : mskstate.target.kibler_one_approach.value,				
				"lat_muscle_approach" : mskstate.target.lat_muscle_approach.value,
				"hk_impingement_approach" : mskstate.target.hk_impingement_approach.value,
				"empty_can_approach" : mskstate.target.empty_can_approach.value,
				"full_can_approach" : mskstate.target.full_can_approach.value,
				"spine_quadrant_approach" : mskstate.target.spine_quadrant_approach.value,
				"trendelenberg_sign_approach" : mskstate.target.trendelenberg_sign_approach.value,
				"hip_quadrant_approach" : mskstate.target.hip_quadrant_approach.value,
				"post_impingement_approach" : mskstate.target.post_impingement_approach.value,
				"infraspinatus_strength_approach" : mskstate.target.infraspinatus_strength_approach.value,
				"combined_elevation_approach" : mskstate.target.combined_elevation_approach.value,
				"trunk_forward_approach" : mskstate.target.trunk_forward_approach.value,
				"trunk_extension_approach" : mskstate.target.trunk_extension_approach.value,
				"trunk_side_approach" : mskstate.target.trunk_side_approach.value,
				"leg_length_approach" : mskstate.target.leg_length_approach.value,
				"hamstring_length_approach" : mskstate.target.hamstring_length_approach.value,
				"iliopsoas_muscle_approach" : mskstate.target.iliopsoas_muscle_approach.value,
				"quad_musclelength_approach" : mskstate.target.quad_musclelength_approach.value,
				"hip_internal_approach" : mskstate.target.hip_internal_approach.value,
				"hip_external_approach" : mskstate.target.hip_external_approach.value,
				"piriformis_ms_approach" : mskstate.target.piriformis_ms_approach.value,
				"df_lunge_test_approach" : mskstate.target.df_lunge_test_approach.value,
				"single_leg_approach" : mskstate.target.single_leg_approach.value,
				"glute_level_approach" : mskstate.target.glute_level_approach.value,
				"shoulders_internal_impression" : mskstate.target.shoulders_internal_impression.value,
				"gird_erg_impression" : mskstate.target.gird_erg_impression.value,
				"kibler_one_impression" : mskstate.target.kibler_one_impression.value,
				"lat_muscle_impression" : mskstate.target.lat_muscle_impression.value,
				"lat_muscle_approach" : mskstate.target.lat_muscle_approach.value,
				"hk_impingement_impression" : mskstate.target.hk_impingement_impression.value,
				"empty_can_impression" : mskstate.target.empty_can_impression.value,
				"full_can_impression" : mskstate.target.full_can_impression.value,
				"spine_quadrant_impression" : mskstate.target.spine_quadrant_impression.value,
				"trendelenberg_sign_impression" : mskstate.target.trendelenberg_sign_impression.value,
				"hip_quadrant_impression" : mskstate.target.hip_quadrant_impression.value,
				"post_impingement_impression" : mskstate.target.post_impingement_impression.value,
				"infraspinatus_strength_impression" : mskstate.target.infraspinatus_strength_impression.value,
				"combined_elevation_impression" : mskstate.target.combined_elevation_impression.value,
				"trunk_forward_impression" : mskstate.target.trunk_forward_impression.value,
				"trunk_extension_impression" : mskstate.target.trunk_extension_impression.value,
				"trunk_side_impression" : mskstate.target.trunk_side_impression.value,
				"leg_length_impression" : mskstate.target.leg_length_impression.value,
				"hamstring_length_impression" : mskstate.target.hamstring_length_impression.value,
				"iliopsoas_muscle_impression" : mskstate.target.iliopsoas_muscle_impression.value,
				"quad_musclelength_impression" : mskstate.target.quad_musclelength_impression.value,
				"hip_internal_impression" : mskstate.target.hip_internal_impression.value,
				"hip_external_impression" : mskstate.target.hip_external_impression.value,
				"piriformis_ms_impression" : mskstate.target.piriformis_ms_impression.value,
				"df_lunge_test_impression" : mskstate.target.df_lunge_test_impression.value,
				"single_leg_impression" : mskstate.target.single_leg_impression.value

				
			}
			
		dispatch({ type: ADD_MSKASSESSMENT});
		return axios.post(AppConfig.apiurl+'/api/createAssessment', payload, { headers: AuthHeader.header })
			.then( response => {       
				if(response.status==200){ 
					var resdata=response.data;
					if(resdata.status===1){
						allMskAssessment()(dispatch);
						NotificationManager.success(resdata.message);               
						dispatch({ type: ADD_MSKASSESSMENT_SUCCESS});
					}else{
						NotificationManager.error(resdata.message); 
						dispatch({ type: ADD_MSKASSESSMENT_FAILURE});			   
					}	
						
				}else{
					NotificationManager.error('MSK Assessment not added');	
					dispatch({ type: ADD_MSKASSESSMENT_FAILURE});	  
				}  
				
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
				dispatch({ type: ADD_MSKASSESSMENT_FAILURE});
			});		

}


export const fetchMskAssessment = (rowdata) => async (dispatch) => {
	
	var payload={
		"studentid":rowdata.user_id,
		"assessment_date":rowdata.assessment_date
	}
	
	  dispatch({ type: MSKASSESSMENT_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/createEditAssessment', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;	
				var resvalue=resdata.data;			
				dispatch({ type: FETCH_MSKASSESSMENT, payload:resvalue[0]}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}

export const editMskAssessment = (mskstate) => async (dispatch) => {
	
	
		var payload={
			"userid":mskstate.target.userid.value,
			"assdate":mskstate.target.assdate.value,
			"pa_id":mskstate.target.pa_id.value,
			"quarter":mskstate.target.quarter.value,
			"mskassessor":mskstate.target.mskassessor.value,
			"mskskill":mskstate.target.mskskill.value,
			"medicalhistory":mskstate.target.medicalhistory.value,
			"medicalrecord":mskstate.target.medicalrecord.value,
			"allergies":mskstate.target.allergies.value,
			"injuryhistory":mskstate.target.injuryhistory.value,
			"head":mskstate.target.head.value,
			"shoulders":mskstate.target.shoulders.value,
			"thoracic_spine":mskstate.target.thoracic_spine.value,
			"lumbar_spine":mskstate.target.lumbar_spine.value,
			"spine_pelvis":mskstate.target.spine_pelvis.value,
			"knee_posture":mskstate.target.knee_posture.value,
			"feet":mskstate.target.feet.value,
			"glenohumeral_rhythm":mskstate.target.glenohumeral_rhythm.value,
			"glenohumeral_rhythm": mskstate.target.glenohumeral_rhythm.value,
			"shoulders_internal_rota_n_rt": mskstate.target.shoulders_internal_rota_n_rt.value,
			"shoulders_internal_rota_n_lt": mskstate.target.shoulders_internal_rota_n_lt.value,
			"shoulders_external_rota_rt": mskstate.target.shoulders_external_rota_rt.value,
			"shoulders_external_rota_lt": mskstate.target.shoulders_external_rota_lt.value,
			"gird_erg_rt": mskstate.target.gird_erg_rt.value,
			"gird_erg_lt": mskstate.target.gird_erg_lt.value,
			"kibler_one_rt_one": mskstate.target.kibler_one_rt_one.value,
			"kibler_one_rt_two": mskstate.target.kibler_one_rt_two.value,
			"kibler_one_lt_one": mskstate.target.kibler_one_lt_one.value,
			"kibler_one_lt_two": mskstate.target.kibler_one_lt_two.value,

			"kibler_two_rt_one": mskstate.target.kibler_two_rt_one.value,
			"kibler_two_rt_two": mskstate.target.kibler_two_rt_two.value,
			"kibler_two_lt_one": mskstate.target.kibler_two_lt_one.value,
			"kibler_two_lt_two": mskstate.target.kibler_two_lt_two.value,

			"kibler_three_rt_one": mskstate.target.kibler_three_rt_one.value,
			"kibler_three_rt_two": mskstate.target.kibler_three_rt_two.value,
			"kibler_three_lt_one": mskstate.target.kibler_three_lt_one.value,
			"kibler_three_lt_two": mskstate.target.kibler_three_lt_two.value,

			"lat_muscle_length_rt": mskstate.target.lat_muscle_length_rt.value,
			"lat_muscle_length_lt": mskstate.target.lat_muscle_length_lt.value,
			"hk_impingement_test_rt": mskstate.target.hk_impingement_test_rt.value,
			"hk_impingement_test_lt": mskstate.target.hk_impingement_test_lt.value,
			"empty_can_test_rt": mskstate.target.empty_can_test_rt.value,
			"empty_can_test_lt": mskstate.target.empty_can_test_lt.value,
			"full_can_test_rt": mskstate.target.full_can_test_rt.value,
			"full_can_test_lt": mskstate.target.full_can_test_lt.value,
			"infraspinatus_strength_rt": mskstate.target.infraspinatus_strength_rt.value,
			"infraspinatus_strength_lt": mskstate.target.infraspinatus_strength_lt.value,
			"spine_quadrant_test_rt": mskstate.target.spine_quadrant_test_rt.value,
			"spine_quadrant_test_lt": mskstate.target.spine_quadrant_test_lt.value,
			"trendelenberg_sign_rt": mskstate.target.trendelenberg_sign_rt.value,
			"trendelenberg_sign_lt": mskstate.target.trendelenberg_sign_lt.value,
			"hip_quadrant_test_rt": mskstate.target.hip_quadrant_test_rt.value,
			"hip_quadrant_test_lt": mskstate.target.hip_quadrant_test_lt.value,
			"post_impingement_test_rt": mskstate.target.post_impingement_test_rt.value,
			"post_impingement_test_lt": mskstate.target.post_impingement_test_lt.value,
			"combined_elevation": mskstate.target.combined_elevation_test.value,
			"trunk_forward_flexion": mskstate.target.trunk_forward_flexion.value,
			"trunk_extension": mskstate.target.trunk_extension.value,
			"trunk_side_flexion_rt": mskstate.target.trunk_side_flexion_rt.value,
			"trunk_side_flexion_lt": mskstate.target.trunk_side_flexion_lt.value,
			"hamstring_length_rt": mskstate.target.hamstring_length_rt.value,
			"hamstring_length_lt": mskstate.target.hamstring_length_lt.value,
			"iliopsoas_muscle_length_rt": mskstate.target.iliopsoas_muscle_length_rt.value,
			"iliopsoas_muscle_length_lt": mskstate.target.iliopsoas_muscle_length_lt.value,
			"quad_muscle_rt": mskstate.target.quad_musclelength_rt.value,
			"quad_muscle_lt": mskstate.target.quad_musclelength_lt.value,
			"hip_internal_rotation_rt": mskstate.target.hip_internal_rotation_rt.value,
			"hip_internal_rotation_lt": mskstate.target.hip_internal_rotation_lt.value,
			"hip_external_rotation_rt": mskstate.target.hip_external_rotation_rt.value,
			"hip_external_rotation_lt": mskstate.target.hip_external_rotation_lt.value,
			"piriformis_ms_length_rt": mskstate.target.piriformis_ms_length_rt.value,
			"piriformis_ms_length_lt": mskstate.target.piriformis_ms_length_lt.value,
			"df_lunge_test_rt": mskstate.target.df_lunge_test_rt.value,
			"df_lunge_test_lt": mskstate.target.df_lunge_test_lt.value,
			"single_leg_eye_open_rt": mskstate.target.single_leg_eye_open_rt.value,
			"single_leg_eye_open_lt": mskstate.target.single_leg_eye_open_lt.value,
			"single_leg_eye_close_rt": mskstate.target.single_leg_eye_closed_rt.value,
			"single_leg_eye_close_lt": mskstate.target.single_leg_eye_closed_lt.value,			
			"leg_length_rt": mskstate.target.leg_length_rt.value,
			"leg_length_lt": mskstate.target.leg_length_lt.value,
			"glute_level_one_rt": mskstate.target.glute_level_one_rt.value,
			"glute_level_one_lt": mskstate.target.glute_level_one_lt.value,
			"glute_level_two_rt": mskstate.target.glute_level_two_rt.value,
			"glute_level_two_lt": mskstate.target.glute_level_two_lt.value,
			"glute_level_three_rt": mskstate.target.glute_level_three_rt.value,
			"glute_level_three_lt": mskstate.target.glute_level_three_lt.value,
			"glute_level_impression": mskstate.target.glute_level_impression.value,
			"tacontrol_level_one": mskstate.target.tacontrol_level_one.value,
			"tacontrol_level_two": mskstate.target.tacontrol_level_two.value,
			"tacontrol_level_three": mskstate.target.tacontrol_level_three.value,
			"tacontrol_level_four": mskstate.target.tacontrol_level_four.value, 
			"tacontrol_level_five": mskstate.target.tacontrol_level_five.value,
			
			"overall_impression_one": mskstate.target.overall_impression_one.value,
			"overall_impression_two": mskstate.target.overall_impression_two.value,
			"overall_impression_three": mskstate.target.overall_impression_three.value,
			"overall_impression_four": mskstate.target.overall_impression_four.value,
			"overall_impression_five": mskstate.target.overall_impression_five.value,
			"overall_impression_six": mskstate.target.overall_impression_six.value,
			"overall_impression_seven": mskstate.target.overall_impression_seven.value,
			"overall_impression_eight": mskstate.target.overall_impression_eight.value,

			"head_approach" : mskstate.target.head_approach.value, 
			"spine_approach" : mskstate.target.spine_approach.value,
			"knee_approach" : mskstate.target.knee_approach.value,
			"feet_approach" : mskstate.target.feet_approach.value,
			"glenohumeral_approach" : mskstate.target.glenohumeral_approach.value,
			"shoulders_internal_approach" : mskstate.target.shoulders_internal_approach.value,
			"gird_erg_approach" : mskstate.target.gird_erg_approach.value,
			"kibler_one_approach" : mskstate.target.kibler_one_approach.value,
			"lat_muscle_approach" : mskstate.target.lat_muscle_approach.value,
			"hk_impingement_approach" : mskstate.target.hk_impingement_approach.value,
			"empty_can_approach" : mskstate.target.empty_can_approach.value,
			"full_can_approach" : mskstate.target.full_can_approach.value,
			"spine_quadrant_approach" : mskstate.target.spine_quadrant_approach.value,
			"trendelenberg_sign_approach" : mskstate.target.trendelenberg_sign_approach.value,
			"hip_quadrant_approach" : mskstate.target.hip_quadrant_approach.value,
			"post_impingement_approach" : mskstate.target.post_impingement_approach.value,
			"infraspinatus_strength_approach" : mskstate.target.infraspinatus_strength_approach.value,
			"combined_elevation_approach" : mskstate.target.combined_elevation_approach.value,
			"trunk_forward_approach" : mskstate.target.trunk_forward_approach.value,
			"trunk_extension_approach" : mskstate.target.trunk_extension_approach.value,
			"trunk_side_approach" : mskstate.target.trunk_side_approach.value,
			"leg_length_approach" : mskstate.target.leg_length_approach.value,
			"hamstring_length_approach" : mskstate.target.hamstring_length_approach.value,
			"iliopsoas_muscle_approach" : mskstate.target.iliopsoas_muscle_approach.value,
			"quad_musclelength_approach" : mskstate.target.quad_musclelength_approach.value,
			"hip_internal_approach" : mskstate.target.hip_internal_approach.value,
			"hip_external_approach" : mskstate.target.hip_external_approach.value,
			"piriformis_ms_approach" : mskstate.target.piriformis_ms_approach.value,
			"df_lunge_test_approach" : mskstate.target.df_lunge_test_approach.value,
			"single_leg_approach" : mskstate.target.single_leg_approach.value,
			"glute_level_approach" : mskstate.target.glute_level_approach.value,
			"shoulders_internal_impression" : mskstate.target.shoulders_internal_impression.value,
			"gird_erg_impression" : mskstate.target.gird_erg_impression.value,
			"kibler_one_impression" : mskstate.target.kibler_one_impression.value,
			"lat_muscle_impression" : mskstate.target.lat_muscle_impression.value,
			"lat_muscle_approach" : mskstate.target.lat_muscle_approach.value,
			"hk_impingement_impression" : mskstate.target.hk_impingement_impression.value,
			"empty_can_impression" : mskstate.target.empty_can_impression.value,
			"full_can_impression" : mskstate.target.full_can_impression.value,
			"spine_quadrant_impression" : mskstate.target.spine_quadrant_impression.value,
			"trendelenberg_sign_impression" : mskstate.target.trendelenberg_sign_impression.value,
			"hip_quadrant_impression" : mskstate.target.hip_quadrant_impression.value,
			"post_impingement_impression" : mskstate.target.post_impingement_impression.value,
			"infraspinatus_strength_impression" : mskstate.target.infraspinatus_strength_impression.value,
			"combined_elevation_impression" : mskstate.target.combined_elevation_impression.value,
			"trunk_forward_impression" : mskstate.target.trunk_forward_impression.value,
			"trunk_extension_impression" : mskstate.target.trunk_extension_impression.value,
			"trunk_side_impression" : mskstate.target.trunk_side_impression.value,
			"leg_length_impression" : mskstate.target.leg_length_impression.value,
			"hamstring_length_impression" : mskstate.target.hamstring_length_impression.value,
			"iliopsoas_muscle_impression" : mskstate.target.iliopsoas_muscle_impression.value,
			"quad_musclelength_impression" : mskstate.target.quad_musclelength_impression.value,
			"hip_internal_impression" : mskstate.target.hip_internal_impression.value,
			"hip_external_impression" : mskstate.target.hip_external_impression.value,
			"piriformis_ms_impression" : mskstate.target.piriformis_ms_impression.value,
			"df_lunge_test_impression" : mskstate.target.df_lunge_test_impression.value,
			"single_leg_impression" : mskstate.target.single_leg_impression.value
			
		}
		
		
	dispatch({ type: EDIT_MSKASSESSMENT});
	return axios.post(AppConfig.apiurl+'/api/editPhysicalAssessment', payload, { headers: AuthHeader.header })
		.then( response => {       
			if(response.status==200){ 
				var resdata=response.data;
				if(resdata.status===1){
					allMskAssessment()(dispatch);
					NotificationManager.success(resdata.message);               
					dispatch({ type: EDIT_MSKASSESSMENT_SUCCESS});
				}else{
					NotificationManager.error(resdata.message); 
					dispatch({ type: EDIT_MSKASSESSMENT_FAILURE});			   
				}	
					
			}else{
				NotificationManager.error('MSK Assessment not updated');	
				dispatch({ type: EDIT_MSKASSESSMENT_FAILURE});	  
			}  
			
			return Promise.resolve(resdata);
			
		})
		.catch( error => { 
			const errormsg=error.message
			NotificationManager.error(errormsg);
			dispatch({ type: EDIT_MSKASSESSMENT_FAILURE});
		});		

}

export const deleteMskAssessment = (pa_id) => async (dispatch) => {
	
	var payload={
		"pa_id":pa_id
	}
	
	  dispatch({ type: MSKASSESSMENT_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/deletePhysicalAssessmentData', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;
				if(resdata.status===1){
					allMskAssessment()(dispatch);
					NotificationManager.success(resdata.message);               
					dispatch({ type: DELETE_MSKASSESSMENT_SUCCESS});
				}else{
					NotificationManager.error(resdata.message); 
					dispatch({ type: DELETE_MSKASSESSMENT_FAILURE});			   
				}
					
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}

export const fetchPostureList = () =>{ 
	
	return (dispatch) => { 
        dispatch({ type: MSKASSESSMENT_ACTION });
        axios.get(AppConfig.apiurl+'/api/getposturelist', { headers: AuthHeader.header })         
        .then(response => {             
            const alldata=response.data.data;
			const head=alldata.head;
			const shoulders=alldata.shoulders;
			const thoracic=alldata.thoracic;
			const lumbar=alldata.lumbar;
			const pelvis=alldata.pelvis;
			const knee=alldata.knee;
			const feet=alldata.feet;
			const glenohumeral=alldata.glenohumeral;
			const abbreviation=alldata.abbreviation;

            dispatch({ type: ALL_POSTURE_HEAD, payload: head });
			dispatch({ type: ALL_POSTURE_SHOULDERS, payload: shoulders });
			dispatch({ type: ALL_POSTURE_THORACIC, payload: thoracic });
			dispatch({ type: ALL_POSTURE_LUMBAR, payload: lumbar });
			dispatch({ type: ALL_POSTURE_PELVIS, payload: pelvis });
			dispatch({ type: ALL_POSTURE_KNEE, payload: knee });
			dispatch({ type: ALL_POSTURE_FEET, payload: feet });
			dispatch({ type: ALL_POSTURE_GLENOHUMERAL, payload: glenohumeral });
			dispatch({ type: ALL_POSTURE_ABBREIVATION, payload: abbreviation });

        });
    } 

	
}


export const getMskReport = (studentid,quarter,seldate) => async (dispatch) => {
	
		var payload={
			"studentid":studentid,
			"adate":seldate,
			"quarter":quarter
		}
	    
	 	 dispatch({ type: MSKASSESSMENT_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/studentmskreportdetails', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;
				var alldata=resdata.data;
				var count = alldata.length;
				if(count===1){					
					var resvalue=resdata.data;			
					dispatch({ type: REPORT_MSKASSESSMENT, payload:resvalue[0]}); 
				}
				
				return Promise.resolve(count);
				
			})
			.catch( error => { 

			});
	
}


export const getMskReportDate = (id) => async (dispatch) => {
	
	var payload={
		"studentid":id
	}
	
	  dispatch({ type: MSKASSESSMENT_ACTION});
	 return axios.post(AppConfig.apiurl+'/api/studentmskdates', payload, { headers: AuthHeader.header })
		.then( response => {   
			var resdata=response.data;			
			var alldata=resdata.data;	
			dispatch({ type: REPORT_MSKDATES, payload:alldata}); 
			return Promise.resolve(resdata);
		})
		.catch( error => { 

		});

}


export const getMedicalDetails = (studentid,seldate, quarter) => async (dispatch) => {
	
	var payload={
		"studentid":studentid,
		"adate":seldate,
		"quarter":quarter
	}
	
	  dispatch({ type: MSKASSESSMENT_ACTION});
	 return axios.post(AppConfig.apiurl+'/api/mskmedicaldetails', payload, { headers: AuthHeader.header })
		.then( response => {   
			var resdata=response.data;						
			dispatch({ type: FETCH_MSKMEDICAL}); 			
			return Promise.resolve(resdata);
			
		})
		.catch( error => { 

		});

}




